import React from "react";
import { useState } from "react";
import LoaderTri from "../../components/Loader/LoaderTri";
import { Image } from "antd";
import { Company } from "../../assets/Data";

const ContactUs = () => {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <div className="container py-5">
      <div className="row">
        <div className="col-md-6 col-sm-12">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7383.635633801893!2d70.784389!3d22.28489!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3959ca3c4795edcb%3A0x1f6f68ee7044a9db!2sMahatma%20Gandhi%20School!5e0!3m2!1sen!2sin!4v1700222556499!5m2!1sen!2sin"
            width="100%"
            height="450"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>

        <div className="col-md-6 col-sm-12">
          <div className="my-5 mx-4 contact-info">
            <p
              className="fw-bold m-0"
              dangerouslySetInnerHTML={{ __html: Company[0].address[1] }}
            ></p>
          </div>

          <div className="contact mx-4">
            {Company[0].phone.alternate.length > 0 &&
              Company[0].phone.alternate.map((item, index) => (
                <p className="fw-bold m-0" key={index}>
                  {index === 0 ? "Ph.: " : ""}
                  {item.label} {item.number}
                </p>
              ))}
            {Company[0].email != "" && (
              <p className="fw-bold m-0">Email: {Company[0].email}</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
